import { DEFAULT_HEX_RADIUS, NEIGHBOR_AXIAL_COORDINATES_CLOCKWISE } from '../../../Constants';
import { GridLocation2d } from './GridLocation2d';

import { TwoDTransform } from './TwoDTransform';


export default class Grid2d {
    name = null;
    axialGrid = [];

    locationItems = [];
    ring = 0;

    radius = null;

    constructor(radius = 0, useLocationZero = false, rotation=-90) {
        this.gridTransform = new TwoDTransform();
        if (radius === 0) {
            this.radius = DEFAULT_HEX_RADIUS - 0.06;
        } else {
            this.radius = radius;
        }
        this.useLocationZero = useLocationZero;
        this.rotation = rotation;
    }

    getGridLocation = (axialX, axialZ) => {
        for (let i = 0; i < this.axialGrid.length; ++i) {
            let gridLocation = this.axialGrid[i];
            if (gridLocation.axialX === axialX && gridLocation.axialZ === axialZ) {
                return gridLocation;
            }
        }
        return null;
    }

    addGridLocation = () => {
        let destination;
        let gridId = this.axialGrid.length;

        if (gridId === 0) {
            if (this.useLocationZero) {
                destination = [0, 0, 0]
            } else {
                destination = NEIGHBOR_AXIAL_COORDINATES_CLOCKWISE[0];
            }
        } else {
            destination = this.getNextAxialCoordinates();
        }

        let newLocation = new GridLocation2d(
            this, gridId, destination[0], destination[2],
            this.radius, this.rotation);
        this.axialGrid.push(newLocation);
        this.setRingNumber();
        this.locationItems.push(null);
        return newLocation;
    }

    updateRadius = (radius) => {
        this.radius = radius;
        this.axialGrid.forEach((item) => item.setRadius(radius));
    }

    getNextAxialCoordinates = () => {
        // Get next on this ring or select zero of next ring. Never 000.
        let lastLocation = this.axialGrid[this.axialGrid.length - 1];
        var targetRing = lastLocation.ring;
        // console.log(`targetRing ${targetRing}`)
        for (let i = 0; i < lastLocation.neighborCoordinates.length; ++i) {
            var neighborCoordinates = lastLocation.neighborCoordinates[i];
            if (neighborCoordinates[0] === 0 &&
                neighborCoordinates[1] === 0 &&
                neighborCoordinates[2] === 0) continue;
            var ring = Math.max(
                Math.abs(neighborCoordinates[0]),
                Math.abs(neighborCoordinates[1]),
                Math.abs(neighborCoordinates[2]));
            // console.log(`cords ${neighborCoordinates} Ring${ring}`)
            if (targetRing === ring) {
                if (!this.getGridLocation(
                    neighborCoordinates[0],
                    neighborCoordinates[2])) return neighborCoordinates;
            }
        }
        let destinationRing = targetRing + 1;
        let destination = [0, -1 * destinationRing, destinationRing];
        this.ring = destinationRing;
        return destination
    }

    getGridLocationByIndex(index) {
        let gridSize = this.axialGrid.length;
        let numberToAdd = index - gridSize + 1;
        if (numberToAdd > 0) {
            for (let i = 0; i < numberToAdd; i++) this.addGridLocation();
        }
        return this.axialGrid[index];
    }

    nextEmptyGridId = () => {
        let gridId = null;
        for (let i = 0; i < this.locationItems.length; i++) {
            if (this.locationItems[i]) continue;
            gridId = i;
            break;
        }
        if (gridId === null) {
            let gridLocation = this.addGridLocation();
            gridId = gridLocation.gridId;
        }
        return gridId;
    }

    installedItemCount = () => {
        let counter = 0;
        for (let i = 0; i < this.locationItems.length; i++) {
            if (this.locationItems[i]) ++counter;
        }
        return counter;
    }

    allAvailableLocations = () => {
        let availableLocations = [];
        for (let i = 0; i < this.locationItems.length; i++) {
            let item = this.locationItems[i];
            if (!item || (item.builtin && !item.locked))
                availableLocations.push(this.axialGrid[i]);
        }
        return availableLocations;
    }

    moveItemToGrid = (item) => {
        let gridId = this.nextEmptyGridId();
        this.moveItemToGridId(item, gridId);
    }

    removeItemFromGrid = (item) => {
        this.locationItems[item.gridId] = null;
        item.grid = null;
        item.gridId = null;
        if (item.transform) item.transform.parent = null;
        if (item.gridTransform) item.gridTransform.parent = null;
    }

    moveItemToGridId = (item, gridId) => {
        if (!item) {
            this.clearGridId(gridId);
            return;
        }
        if (item.grid) item.grid.removeItemFromGrid(item);
        this.getGridLocationByIndex(gridId); // add location to grid.
        if (item.transform) {
            item.transform.parent = this.axialGrid[gridId].transform;
            item.transform.position = { x: 0, y: 0, z: 0 };
        }
        if (item.gridTransform) {
            item.gridTransform.parent = this.axialGrid[gridId].transform;
            item.gridTransform.position = { x: 0, y: 0, z: 0 };
        }
        // consider using local variables for these ._grid=

        // item.grid = this;
        // item.gridId = gridId;

        this.locationItems[gridId] = item;
    }

    show = () => {
        this.gridTransform.setEnabled(true);
    }

    hide = () => {
        this.gridTransform.setEnabled(false);
    }

    clearGrid = (dispose = false) => {
        this.locationItems.forEach((locationItem) => {
            if (locationItem !== null && locationItem !== undefined) {
                this.removeItemFromGrid(locationItem);
                if (dispose) {
                    if (locationItem.mesh) locationItem.mesh.dispose();
                    if (locationItem.transform) locationItem.transform.dispose();
                }
            }
        });
    }

    clearGridId = (gridId) => {
        let item = this.locationItems[gridId]
        if (item) {
            if (item.mesh) item.mesh.dispose();
            if (item.transform) item.transform.dispose();
            this.removeItemFromGrid(item);
        }
        this.locationItems[gridId] = null;
    }

    setRingNumber = () => {
        let lastLocation = this.axialGrid[this.axialGrid.length - 1];
        this.ring = Math.max(
            Math.abs(lastLocation.axialX),
            Math.abs(lastLocation.axialY),
            Math.abs(lastLocation.axialZ));
    }

    dispose = () => {
        this.gridTransform.dispose();
    }

    render = () => {
        return <div id={'gridParent'}>
            {this.locationItems.map((locationItem, gridId) => {
                if (locationItem !== null && locationItem !== undefined) {
                    return this.getGridLocationByIndex(gridId).render(locationItem);
                }
            })}
        </div>
    }

}

// public enum HexDirection
// {
//     NE, E, SE, SW, W, NW
// }
//
